import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: #faf8f5;
  padding: 70px 0 30px;
  overflow-y: auto;
`;

export const MenuItemsContainer = styled.div`
  width: calc(100% - 16px);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;

  margin: 0 8px;
  box-sizing: border-box;
`;

export const ItemWrapper = styled.div`
  box-shadow: 0.5px 1.5px #9c8162;
  transition: 0.3s;
  border-radius: 15px;
  border-width: 1px;
  border-style: solid;
  border-color: black;
  color: black;
  display: flex;
  flex-direction: column;
  background-color: #fdf8f2;
  width: 100%;
  height: 60px;
`;

export const ImageWrapper = styled.div`
  flex: 1;
  padding: 10px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const Image = styled.img`
  margin-block: 10px;
`;

export const Text = styled.p`
  font-size: 12px;
  color: black;
  font-weight: 400;
  text-align: center;
  margin-block: 5px;
  margin-inline: 5px;
`;

export const Footer = styled.footer`
  width: 100%;
  min-height: 52px;
  background-color: #9c8162;

  display: flex;
  align-items: center;
  justify-content: center;

  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 20;

  padding: 8px 12px;
  box-sizing: border-box;

  a {
    font-size: 12px;
    margin: 0;
    text-decoration: none;
    color: #fdf8f2;
    text-align: center;
  }
`;

export const IconWrapper = styled.div`
  width: 30px;
  height: 30px;
`;

export const Header = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  position: fixed;
  top: 0;
  z-index: 10;

  background-color: #9c8162;

  color: #f8f5ef;

  p {
    margin-left: 12px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: .5px;
  }
`;
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 60px;
  padding-bottom: 30px;
`;

export const ItemContainer = styled.div<{ isFirst: any }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 18px 16px;
  margin: 0 16px;

  border-top: ${(props) =>
    props.isFirst ? "none" : "1px solid rgba(200,164,90,.35)"};

  transition: .25s;

  &:active {
    background: rgba(200,164,90,.08);
  }
`;

export const TextWrapper = styled.div<{ isDescription?: any }>`
  display: flex;
  flex-direction: ${(props) =>
    props.isDescription ? "column" : "row"};
  align-items: baseline;
  gap: 6px;
`;

export const Title = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #1f1f1f;
  text-transform: uppercase;
  letter-spacing: .4px;
`;

export const Subtitle = styled.p`
  margin: 0;
  color: #9c8162;
  font-size: 10px;
  font-weight: 500;
  margin-left: 5px
`;

export const Price = styled.p`
  margin: 0;
  color: black;
  font-size: 12px;
  font-weight: 700;
`;

export const SectionTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 28px 16px 14px;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #9c8162;
  }

  p {
    margin: 0;
    color: #1f1f1f;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
  }
`;

export const Description = styled.p`
  margin-top: 4px;
  color: #9c8162;
  font-size: 13px;
  line-height: 18px;
  text-transform: lowercase;
`;

export const PricesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  flex-shrink: 0;
`;

export const PriceOption = styled.div`
  display: flex;
  align-items: baseline;
  gap: 3px;
  white-space: nowrap;

  span {
    color: #b88b39;
    font-size: 12px;
    font-weight: 500;
  }
`;

export const PremiumNote = styled.p`
  margin: 26px 20px 10px;
  color: #9c8162;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  line-height: 19px;
`;

export const PremiumCard = styled.div`
  width: calc(100% - 32px);
  min-height: 72px;
  margin: 30px 16px 20px;
  padding: 12px 18px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;

  border: 1px solid #9c8162;
  border-radius: 16px;

  background: linear-gradient(
    135deg,
    #fdf8f2 0%,
    #f3e7d7 100%
  );

  box-shadow: 0 3px 8px rgba(156, 129, 98, 0.22);
  box-sizing: border-box;
  cursor: pointer;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:active {
    transform: scale(0.98);
  }
`;

export const PremiumIconWrapper = styled.div`
  width: 42px;
  height: 42px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid #9c8162;
  border-radius: 50%;
  color: #9c8162;
  flex-shrink: 0;

  span {
    font-size: 20px;
    line-height: 1;
  }
`;

export const PremiumTitle = styled.p`
  margin: 0;
  color: #1f1f1f;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const PremiumSubtitle = styled.p`
  margin: 4px 0 0;
  color: #9c8162;
  font-size: 11px;
  font-weight: 500;
`;

export const BottomNote = styled.p`
  margin: 18px auto 24px;
  width: fit-content;

  color: #9c8162;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
`;
